var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.value || _vm.get(_vm.item, _vm.field.key) || '-'))]),(_vm.subValue)?_c('div',{staticClass:"text-muted"},[_vm._v(" "+_vm._s(_vm.subValue)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }